import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './LoginComponent/login.component';
import { HomeComponent } from './HomeComponent/home.component';
import { PersonViewComponent } from './PersonComponent/PersonViewComponent/person.view.component';
import { PersonFormComponent } from './PersonComponent/PersonFormComponent/person.form.component';
import { SearchComponent } from './shared/views/SearchComponent/search.component';
import { EmployerViewComponent } from './EmployerComponent/EmployerViewComponent/employer.view.component';
import { EmployerFormComponent } from './EmployerComponent/EmployerFormComponent/employer.form.component';
import { ProjectFormComponent } from './ProjectComponent/ProjectFormComponent/project.form.component';
import { ProjectViewComponent } from './ProjectComponent/ProjectViewComponent/project.view.component';
import { ErrorComponent } from './shared/views/ErrorComponent/error.component';
import { NewRegisterFormComponent } from './RegisterComponent/NewRegisterFormComponent/new.register.form.component';
import { NewRegisterViewComponent } from './RegisterComponent/NewRegisterViewComponent/new.register.view.component';
import { NewProjectFormComponent } from './ProjectComponent/NewProjectFormComponent/new.project.form.component';
import { NewProjectViewComponent } from './ProjectComponent/NewProjectViewComponent/new.project.view.component';

import { NotificationComponent } from './NotificationComponent/notification.component';
import { RegisterViewComponent } from './RegisterComponent/RegisterViewComponent/register.view.component';
import { RegisterFormComponent } from './RegisterComponent/RegisterFormComponent/register.form.component';
import { ExportImportComponent } from './ExportImportComponent/exportimport.component';
import { ListComponent } from './ListComponent/list.component';
import { StatisticComponent } from './StatisticComponent/statistic.component';
import { ReportComponent } from './ReportComponent/ReportComponent/report.component';
import { NewReportComponent } from './ReportComponent/NewReportComponent/new.report.component';
import { AuthGuard } from './auth';
import { ImportRKImage } from './ImportRKImage/importrkimage.component';
import { SecurityAgreementFormComponent } from './SecurityAgreementComponent/SecurityAgreementFormComponent/security.agreement.form.component';
import { SecurityAgreementViewComponent } from './SecurityAgreementComponent/SecurityAgreementViewComponent/security.agreement.view.component';
import { DebriefingSAPOComponent } from './DebriefingSAPOComponent/debriefingsapo.component';
import { AdministrationComponent } from './AdministrationComponent/administration.component';

const appRoutes: Routes = [
  { 
    path: 'login', 
    component: LoginComponent 
  }, { 
    path: 'error', 
    component: ErrorComponent 
  }, { 
    path: 'home', 
    component: HomeComponent, 
    canActivate: [AuthGuard] 
  }, { 
    path: 'importrkimage', 
    component: ImportRKImage, 
    canActivate: [AuthGuard]
  } ,{ 
    path: 'exportimport', 
    component: ExportImportComponent, 
    canActivate: [AuthGuard]
  }, { 
    path: 'list', 
    component: ListComponent, 
    canActivate: [AuthGuard]
  }, { 
    path: 'statistic', 
    component: StatisticComponent, 
    canActivate: [AuthGuard]
  },{ 
    path: 'notification', 
    component: NotificationComponent, 
    canActivate: [AuthGuard]
  },{ 
    path: 'debriefingsapo', 
    component: DebriefingSAPOComponent, 
    canActivate: [AuthGuard]
  },{ 
    path: 'oldreport', 
    component: ReportComponent, 
    canActivate: [AuthGuard]
  },{ 
    path: 'report', 
    component: NewReportComponent, 
    canActivate: [AuthGuard]
  },{ 
    path: 'administration', 
    component: AdministrationComponent, 
    canActivate: [AuthGuard]
  },{ 
    path: ':type', 
    component: SearchComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'securityAgreement/:type', 
    component: SecurityAgreementFormComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'securityAgreement/view/:id', 
    component: SecurityAgreementViewComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'securityAgreement/:type/:id', 
    component: SecurityAgreementFormComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'registercontrol/:type', 
    component: NewRegisterFormComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'registercontrol/view/:id', 
    component: NewRegisterViewComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'registercontrol/:type/:id', 
    component: NewRegisterFormComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'person/:type', 
    component: PersonFormComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'project/:type', 
    component: NewProjectFormComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'project/view/:id', 
    component: NewProjectViewComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'project/:type/:id', 
    component: NewProjectFormComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'person/view/:id', 
    component: PersonViewComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'person/:type/:id', 
    component: PersonFormComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'employer/:type', 
    component: EmployerFormComponent, 
    canActivate: [AuthGuard] 
  },{
    path: 'employer/view/:id', 
    component: EmployerViewComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: 'employer/:type/:id', 
    component: EmployerFormComponent, 
    canActivate: [AuthGuard] 
  },{ 
    path: '', 
    redirectTo: 'home', 
    pathMatch: 'full', 
    canActivate: [AuthGuard] 
  }, { 
    path: '**', 
    redirectTo: 'home', 
    pathMatch: 'full', 
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      // { enableTracing: true } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}
